/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAcl {
    getFixupPrototypeFunction() { return DashboardDefinitionAcl.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAcl>): DashboardDefinitionAcl {
        let obj = Object.assign(new DashboardDefinitionAcl(), model);
        DashboardDefinitionAcl.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAcl>): DashboardDefinitionAcl {
        if (!model) return null;
        return DashboardDefinitionAcl.newInstance(<DashboardDefinitionAcl> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAcl) {
        if (!obj) return;

        models.DashboardDefinitionAcl.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAcl): boolean {
        Object.setPrototypeOf(obj, DashboardDefinitionAcl.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.entries) {
            for (let val of this.entries) {
                models.DashboardDefinitionAclEntry.fixupPrototype(val);
            }
        }
    }

    entries: Array<models.DashboardDefinitionAclEntry>;

    portalPath: Array<string>;

}
